import { Box, Button, Container, Heading, Img, Stack, Text } from '@chakra-ui/react'

import { makeServerProps } from '@/server/query'

import makePage from '@/client/services/pages/makePage'
import { getPartnerLogoURL } from '@/client/services/url'
import { STARS_COLLEGE_NETWORK_MAILING_LIST_NAME } from '@/client/services/waitlist'

import WavyHeading from '@/components/About/WavyHeading'
import WhoWeAre from '@/components/About/WhoWeAre'
import BrandMark from '@/components/Icons/BrandMark'
import Section from '@/components/Landing/Section'
import Layout from '@/components/Layout/Layout'
import {
  COLLEGE_PARTNER_DETAILS,
  STARS_COLLEGE_NETWORK_PARTNERS,
} from '@/components/Partners/constants'
import PartnerLogosWrap from '@/components/Partners/PartnerLogosWrap'
import ShwLink from '@/components/ShwLink'
import { STARS_URL } from '@/components/STARSCollegeNetwork/constants'
import STARSHowToParticipate from '@/components/STARSCollegeNetwork/STARSHowToParticipate'
import JoinWaitlistForm from '@/components/Waitlist/JoinWaitlistForm'

function STARSCollegeNetwork(): JSX.Element {
  return (
    <Layout title="STARS College Network">
      <Section bg="primary.solid">
        <Container>
          <Stack align="center" spacing="24px">
            <Stack direction="row" justify="center" align="flex-end" spacing="16px">
              <BrandMark textColor="primary.contrast" height="48px" />
              <Img src={getPartnerLogoURL('stars-logo.svg')} height="72px" />
            </Stack>
            <Heading
              as="h1"
              textAlign="center"
              size="3xl"
              color="primary.contrast"
              mt="16px"
              mb="32px"
            >
              Welcome, STARS participants!
            </Heading>
            <Text
              color="primary.contrast"
              maxWidth="1200px"
              fontSize="20px"
              lineHeight="28px"
              textAlign="center"
              my="16px"
            >
              Schoolhouse.world and Khan Academy are partnering together with the STARS network to
              spearhead an initiative to prepare small town and rural students for college-level
              mathematics courses at some of the nation&apos;s most well-known colleges and
              universities.
            </Text>
            <Box
              maxWidth="700px"
              mt="16px"
              width="90%"
              borderBottom="2px solid"
              borderColor="primary.contrast"
            />
            <Box maxWidth="1200px" textAlign="center" mt={10}>
              <Heading size="lg" color="primary.contrast">
                Interested in using Schoolhouse as an ongoing resource?
              </Heading>
              <Heading size="lg" color="primary.contrast" mb={4}>
                Sign up for the mailing list and stay tuned for updates!
              </Heading>
              <JoinWaitlistForm
                waitlistName={STARS_COLLEGE_NETWORK_MAILING_LIST_NAME}
                buttonVariant="outline"
              />
            </Box>
          </Stack>
        </Container>
      </Section>
      <Container centerContent maxWidth="1100px">
        <WavyHeading text="STARS College Network" width="280px" color="yellow.solid" />
        <PartnerLogosWrap
          partners={STARS_COLLEGE_NETWORK_PARTNERS.map(partner => COLLEGE_PARTNER_DETAILS[partner])}
          scaleMultiplier={0.5}
        />
        <ShwLink href={STARS_URL} mb={6} mt={12}>
          <Button variant="outline">Learn More</Button>
        </ShwLink>
      </Container>
      <Section bg="bg.subtle">
        <Container>
          <STARSHowToParticipate />
        </Container>
      </Section>
      <WhoWeAre />
    </Layout>
  )
}

const STARSCollegeNetworkPage = makePage(STARSCollegeNetwork, {
  onboardingUsers: 'allowed',
})
export const getServerSideProps = makeServerProps(STARSCollegeNetworkPage)
export default STARSCollegeNetworkPage
